export const SAP_OFFERT_STORAGE_KEY = 'DPV_SAPOferta';
export const EXCLUDE_RIBBON_PREFIXES = ['DPD_', 'DPS_', 'DPT_'];
